import { Component, ViewEncapsulation, Inject, OnInit, OnDestroy } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialogRef, MatSnackBar } from '@angular/material';
import { FormBuilder, FormGroup } from '@angular/forms';

import { Observable, Subscription } from 'rxjs';
import { Store } from "store";

import { User, UserInfo } from "app/core/models/user.model";

// import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';

import { ProfileService } from './profile.service';

// import { User,  } from "./profile.model";

@Component({
  selector: 'app-profile-form',
  templateUrl: './profile-form.component.html',
  styleUrls: ['./profile-form.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ProfileFormDialogComponent implements OnInit {
  userInfo$: Observable<UserInfo>;
  subscription: Subscription;



  user: User;

  userForm: FormGroup;
  photoUrl: string;
  uid: string;

  constructor(
    public matDialogRef: MatDialogRef<ProfileFormDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: any,
    private _formBuilder: FormBuilder,
    private serviceProfile: ProfileService,
    private _matSnackBar: MatSnackBar,
    private store: Store
  ) { 
    // Get user information
    this.userForm = this.createProfileForm();
  }

  ngOnInit(): void {
    this.userInfo$ = this.store.select<UserInfo>('userInfo');

    this.userInfo$.subscribe((userInfo: UserInfo) => {
        
          this.userForm.reset({
            name: userInfo.name,
            second_name: userInfo.second_name,
            phone: userInfo.phone,
            country: userInfo.country,
            photoUrl: userInfo.photoUrl
          })
          
          this.photoUrl = userInfo.photoUrl;
    })
  }

  update(userForm) {
    this.serviceProfile.updateProfile(userForm.getRawValue())
              .subscribe(res => {
                this._matSnackBar.open('Tu perfil fue actualizado exitosamente', '', {
                  duration: 3000,
                });
              }, (err) => {
                this._matSnackBar.open('Error al actulizar tu perfil, intente de nuevo', '', {
                  duration: 5000,
                });
              });
  }

  /**
   * Create profile form
   *
   * @returns {FormGroup}
   */
  createProfileForm(): FormGroup {
    return this._formBuilder.group({
      name: [''],
      second_name: [''],
      phone: [''],
      country: [''],
      photoUrl: ['']
    })
  }
}
